module.exports = __webpack_public_path__ + "static/media/app-condutor-icone-android.42ed8fe3.webp";